import { Inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Location } from "@angular/common";
import { AuthService } from '../auth/auth.service'
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { ClaimCategory } from '../core/enums/auth/ClaimCategory';
import { ClaimSubCategory } from '../core/enums/auth/ClaimSubCategory';
import { ClaimValue } from '../core/enums/auth/ClaimValue';
import { catchError, concatMap, map } from 'rxjs/operators';
import { MSAL_GUARD_CONFIG } from './msal/constants';
import { MsalGuardConfiguration } from './msal/msal-guard-config';
import { MsalService } from './msal/msal-service';

@Injectable()
export class AuthGuardOrganisationService implements CanActivate {

  constructor(private authService: AuthService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private msalService: MsalService,
    private location: Location) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.msalService.handleRedirectObservable()
      .pipe(
        concatMap(() => {
          if (!this.msalService.instance.getAllAccounts().length) {
            return this.loginInteractively(state.url);
          }
          return of(true);
        }),
        concatMap((res) => {
          if (res == true) {
            return this.authService.getClaims$().pipe(map((claims) => {
              if (this.authService.hasPermissionCenter("", ClaimValue.Name("Read"), ClaimCategory.Name("OrganizationManagement"), ClaimSubCategory.Name("None"))) {
                return true;
              }
              if (this.authService.hasPermissionCenter("", ClaimValue.Name("Read"), ClaimCategory.Name("MemberManagement"), ClaimSubCategory.Name("All"))) {
                return true;
              }
              if (this.authService.hasPermissionCenter("", ClaimValue.Name("Read"), ClaimCategory.Name("MemberManagement"), ClaimSubCategory.Name("Self"))) {
                return true;
              }
              if (this.authService.hasPermissionCenter("", ClaimValue.Name("Read"), ClaimCategory.Name("CenterManagement"), ClaimSubCategory.Name("None"))) {
                return true;
              }
              return false;
            }));
          }
          return of(false);
        }),
        catchError((e, c) => {
          console.log(e);
           return this.loginInteractively(state.url);
        })
      );

  }

  /**
    * Builds the absolute url for the destination page
    * @param path Relative path of requested page
    * @returns Full destination url
    */
  getDestinationUrl(path: string): string {
    // Absolute base url for the application (default to origin if base element not present)
    const baseElements = document.getElementsByTagName("base");
    const baseUrl = this.location.normalize(baseElements.length ? baseElements[0].href : window.location.origin);

    // Path of page (including hash, if using hash routing)
    const pathUrl = this.location.prepareExternalUrl(path);

    // Hash location strategy
    if (pathUrl.startsWith("#")) {
      return `${baseUrl}/${pathUrl}`;
    }

    // If using path location strategy, pathUrl will include the relative portion of the base path (e.g. /base/page).
    // Since baseUrl also includes /base, can just concatentate baseUrl + path
    return `${baseUrl}${path}`;
  }

  private loginInteractively(url: string): Observable<boolean> {
    const redirectStartPage = this.getDestinationUrl(url);
    this.msalService.loginRedirect({
      redirectStartPage,
      scopes: [],
      ...this.msalGuardConfig.authRequest,
    });
    return of(false);
  }

}
